import {
  DateFormat,
  type DateType,
  formatDate,
  formatTime,
} from '@leland-dev/leland-ui-library';

import { type Scalars } from '../../__generated-gql-types__/globalTypes';
import { getUrlString } from '../../utils/url';

export const openBootcampCohortCheckoutPage = (
  cohortUrn: Scalars['BootcampCohortUrn']['output'],
) => {
  const link = getUrlString(`/checkout`, {
    bootcampCohort: cohortUrn,
  });

  window.open(link, '_blank');
};

export interface BootcampCohortDateInfo {
  sessions: Array<{
    startAt: DateType;
  }>;
  startAt: DateType;
  endAt: DateType;
}

export const formatBootcampCohortDate = (cohort: BootcampCohortDateInfo) => {
  const numberOfSessions = cohort.sessions.length;
  const baseDateString = formatDate(cohort.startAt, DateFormat.SHORT_MONTH_DAY);
  if (numberOfSessions > 1) {
    return `${baseDateString} - ${formatDate(cohort.endAt, DateFormat.STANDARD)}`;
  }
  return `${baseDateString} · ${formatTime(cohort.startAt)}`;
};
